// Translations for the Meetings page (Meetings.js).
const meetingsDict = [
  { en: "Meetings & Decisions", sw: "Mikutano na Maamuzi" },
  { en: "Create Meeting", sw: "Unda Mkutano" },
  { en: "Loading meetings...", sw: "Inapakia mikutano..." },
  { en: "No meetings found.", sw: "Hakuna mikutano iliyopatikana." },
  { en: "Create one to start collecting proposals and minutes.", sw: "Unda mmoja ili kuanza kukusanya mapendekezo na kumbukumbu." },
  { en: "View", sw: "Angalia" },
  { en: "Back to meetings", sw: "Rudi kwenye mikutano" },
  { en: "Date:", sw: "Tarehe:" },
  { en: "Location:", sw: "Mahali:" },
  { en: "Chair:", sw: "Mwenyekiti:" },
  { en: "Agenda", sw: "Ajenda" },
  { en: "Proposals", sw: "Mapendekezo" },
  { en: "No proposals yet.", sw: "Hakuna mapendekezo bado." },
  { en: "Suggest a proposal or amendment", sw: "Pendekeza wazo au marekebisho" },
  { en: "Submit proposal", sw: "Wasilisha Pendekezo" },
  { en: "Go to Elections", sw: "Nenda kwenye Uchaguzi" },
  { en: "Minutes", sw: "Kumbukumbu" },
  { en: "Minutes not published yet.", sw: "Kumbukumbu bado hazijachapishwa." },
  { en: "Loading meeting...", sw: "Inapakia mkutano..." },
  { en: "Title", sw: "Kichwa" },
  { en: "Date", sw: "Tarehe" },
  { en: "Time", sw: "Muda" },
  { en: "Location", sw: "Mahali" },
  { en: "Create", sw: "Tengeneza" },
  { en: "Cancel", sw: "Ghairi" },
];

export default meetingsDict;
